<div class="download-template">
  <a [href]="templateUrl" target="_blank">Скачать шаблон</a>
</div>

<form class="upload-form">
  <div class="form-group" *ngIf="fileFieldVisible">
    <input type="file" *ngIf="uploader" name="destinations" ng2FileSelect [uploader]="uploader" (onFileSelected)="onFileSelected()" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
  </div>
</form>
